/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BlueprintDetails {
    getFixupPrototypeFunction() { return BlueprintDetails.fixupPrototype; }

    static newInstance(model: Partial<BlueprintDetails>): BlueprintDetails {
        let obj = Object.assign(new BlueprintDetails(), model);
        BlueprintDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BlueprintDetails>): BlueprintDetails {
        if (!model) return null;
        return BlueprintDetails.newInstance(<BlueprintDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BlueprintDetails) {
        if (!obj) return;

        models.BlueprintDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BlueprintDetails): boolean {
        Object.setPrototypeOf(obj, BlueprintDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resources) {
            for (let val of this.resources) {
                models.ResourcesDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Blueprint ID
     */
    id: string;

    /**
     * Blueprint Name
     */
    name: string;

    /**
     * Blueprints Description
     */
    description: string;

    /**
     * Resource Details
     */
    resources: Array<models.ResourcesDetails>;

    /**
     * Scope of the blueprint
     */
    scope: string;

    /**
     * Status of the blueprint
     */
    status: string;

    /**
     * Who has created the blueprint
     */
    created_by: string;

    /**
     * When was the blueprint created
     */
    created_at: string;

    /**
     * Who has updated the blueprint
     */
    updated_by: string;

    /**
     * When was the blueprint updated
     */
    updated_at: string;

}
